<template>
  <div class="back">
    <router-link to="/">
      <img src="../../assets/img/back-icon.png" alt="Back"/>
    </router-link>
  </div>
</template>

<script>
    export default {
      name: 'Back',
      props: {
        msg: String
      }
    }
</script>

<style scoped>
</style>
